import { render, staticRenderFns } from "./EmailMultiSelect.vue?vue&type=template&id=4a5ce17c&"
import script from "./EmailMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./EmailMultiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports